import Home from '../../components/Home'
export default function HomePage(params) {
    return <Home/>
}